import component from './index';
import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper footer3',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page footer3-page',
    },
    bg: {
      className: 'bg',
      children: 'https://imm.86links.com/assets/landing/footer/template/footer3-bg.png',
    },
    center: {
      className: 'center',
    },
    left: {
      className: 'left-wrap',
      children: '成都经开区 欢迎您',
    },
    right: {
      className: 'right-wrap',
      children: [
        {
          name: 'item0',
          className: 'right-item',
          children: [
            {
              name: 'image',
              children: 'https://imm.86links.com/assets/landing/footer/template/address-icon.png',
              className: 'icon',
            },
            {
              name: 'address',
              children: '成都市龙泉驿区龙泉街道星光中路18号',
              className: 'address',
            },
          ],
        },
        {
          name: 'item1',
          className: 'right-item',
          children: [
            {
              name: 'image',
              children: 'https://imm.86links.com/assets/landing/footer/template/address-icon.png',
              className: 'icon',
            },
            {
              name: 'mobile',
              children: '028-84853326',
              className: 'mobile',
            },
          ],
        },
      ],
    },
  },
};
